import React from 'react';
import PropTypes from 'prop-types';
import { DEFAULT_BREAKPOINTS } from '@nubank/nuds-web/styles/breakpoints';

import ResponsiveImage from './ResponsiveImage';
import ResponsiveImageSize from './ResponsiveImageSize';

const {
  sm, md, lg, xl,
} = DEFAULT_BREAKPOINTS;
const MIN_WIDTH_BREAKPOINTS = {
  0.5: 0,
  0.75: sm,
  1: md,
  2: lg,
  3: xl,
};
const IMAGES_SIZES = [0.5, 0.75, 1, 2, 3];

function getImageInfo(fileName = '') {
  const extension = fileName.split('.').pop();
  const baseName = fileName.substring(
    0,
    fileName.length - extension.length - 1,
  );

  return { baseName, extension };
}

function renderResponsiveImages(
  fileName,
  responsiveImageSizeProps = {},
) {
  // TODO: Verificar se está realmente usando o responsiveImageSizeProps no <ResponsiveImageSize/>
  const { baseName, extension } = getImageInfo(fileName);
  const defaultIndex = 0;

  return IMAGES_SIZES.map((size, index) => {
    const isDefault = index === defaultIndex;
    const fileNameWithSize = `${baseName}@${size}x`;
    const imageFileName = `${fileNameWithSize}.${extension}`;

    const imageProps = {
      ...responsiveImageSizeProps,
      minWidth: MIN_WIDTH_BREAKPOINTS[size],
      default: isDefault,
      path: imageFileName,
      size,
      extension,
    };

    return <ResponsiveImageSize key={fileNameWithSize} {...imageProps} />;
  });
}

function ResponsiveImages(props) {
  const {
    fileName,
    width,
    height,
    alt,
    loading,
    position,
    className,
  } = props;

  const imageProps = {
    width,
    height,
    alt,
    loading,
    position,
  };

  return (
    <ResponsiveImage className={className} width={width} height={height} alt={alt}>
      {renderResponsiveImages(fileName, imageProps)}
    </ResponsiveImage>
  );
}

ResponsiveImages.defaultProps = {
  alt: '',
  className: undefined,
  height: undefined,
  position: 'center',
  width: undefined,
  loading: undefined,
};

ResponsiveImages.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  fileName: PropTypes.string.isRequired,
  height: PropTypes.number,
  loading: PropTypes.string,
  position: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default ResponsiveImages;
